module.exports = "/lucky-balls/img/regular_game/background.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/background.png
// module id = 1122
// module chunks = 0